<template>
    <div>
        <template v-if="inputType === 'word'">
            <!-- <i v-if="hasAudio" class="iconfont icon-ecard-audio-input" @click="inputType = 'audio'"></i> -->
            <div class="sjtu-sent">
                <textarea
                    v-if="owner === 'SJTU'"
                    ref="textInput"
                    autocomplete="off"
                    class="el-textarea"
                    v-model="userInput"
                    rows="1"
                    cols=""
                    @keyup.enter="sendSjtuMessage"
                    @click.stop="noop"
                    @focus="handleInputFocus($event)"
                    @blur="handleInputBlur"
                />
                <input
                    v-else
                    ref="textInput"
                    type="text"
                    autocomplete="off"
                    class="el-input"
                    v-model="userInput"
                    @keyup.enter="sendMessage"
                    @click.stop="noop"
                    @focus="handleInputFocus($event)"
                    @blur="handleInputBlur"
                    size="medium"
                    placeholder="开始对话吧~"
                />
                <img :src="sent" alt="sent" class="el-input-sent" @click="sendMessage" />
                <button class="sjtu-btn" v-if="owner === 'SJTU'" @click="sendSjtuMessage">发送</button>
                <!-- <button class="" v-else @click="sendMessage">发送</button> -->
            </div>
        </template>
        <!-- <template v-if="inputType === 'audio'">
            <i class="iconfont icon-ecard-keyboard" @click="inputType = 'word'"></i>
            <div
                v-if="source === 'PC'"
                class="wedget-in"
                :class="{ active: ifWedgeInActive }"
                @mousedown.stop.prevent="startRecord"
                @mouseup.stop.prevent="stopRecord"
            >
                {{ ifWedgeInActive ? '松开 发送' : '按住 说话' }}
            </div>
            <div v-else class="wedget-in" :class="{ active: ifWedgeInActive }" @touchstart.stop.prevent="startRecord" @touchend.stop.prevent="stopRecord">
                {{ ifWedgeInActive ? '松开 发送' : '按住 说话' }}
            </div>
        </template> -->
        <!-- <audio
      ref="audio"
      hidden="true"
      type="audio/wav"
      :src="curAudioSrc"
      @error="handleAudioError"
      @ended="handleAudioEnded"
    ></audio>-->
        <div v-show="hintList.length > 0" class="word-ask-cover"></div>
        <div v-show="hintList.length > 0" class="word-ask-hint">
            <div v-for="(item, index) of hintList" :key="index" v-html="item.content" @click="clickHintHandler(item.name)" />
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import wx from 'weixin-js-sdk'
import Recorder from './recorder'
import {
  sendH5Message,
  H5AxiosSource,
  sendH5VoiceMessage,
  sjtuSendH5Message,
  sjtuRoot,
  H5AxiosInput,
  getInputQuick
} from '../Service/api.js'
import AnswerModel from './AnswerModel'

let answerIndex = 0

export default {
  props: {
    h5ConfigData: {
      type: Object
    },

    conversition: {
      type: Array
    },

    curAudioSrc: {
      type: String
    },

    voiceLevel: {
      type: Number
    },

    curRecordTime: {
      type: [String, Number]
    },

    isRequest: {
      type: Boolean
    },
    owner: String,
    search: String
  },

  data () {
    return {
      inputType: 'word',
      userInput: '',
      ifWedgeInActive: false,
      recorder: null,
      audioSrcType: '',
      audioDom: null,
      source: '',
      isWXReady: false,
      year: '',
      sent: '',
      hintList: []
    }
  },

  computed: {
    ifResVoice () {
      return (
        this.h5ConfigData.ttsConfiguration === 3 || this.h5ConfigData.ttsConfiguration === 4
      )
    },
    hasAudio () {
      return this.owner && this.owner === 'SJTU'
    }
  },

  mounted () {
    if (this.owner === 'SJTU') {
      this.year = (new Date()).getFullYear()
      this.initWelcomes()
    } else {
      this.initPC()
    }
    if (this.hasAudio) {
      const arr = window.location.search.match(/(\?|&)source=([^&]*)/)
      if (arr && arr.length > 2) {
        this.source = arr[2].toUpperCase()
      }
      const func = `init${this.source}`
      if (typeof this[func] === 'function') {
        this[func]()
      }
      if (this.source === 'PC') {
        this.initPC()
      } else if (this.source === 'APP') {
        this.initAPP()
      } else if (this.source === 'WECHAT') {
        this.initWECHAT()
      }
    }
    this.sent = 'https://oss.talkinggenie.com/ms-system/ecardServer/test/gallery/1000002541-5788768ecc784d02989c1809bab3818c.png'
  },

  watch: {
    userInput (val) {
      this.hintList = []
      if (H5AxiosInput.cancel && {}.toString.call(H5AxiosInput.cancel) === '[object Function]') {
        H5AxiosInput.cancel('cancel request')
      }
      if (val.length >= 2) {
        getInputQuick(this.h5ConfigData.productId, val).then((inputGuide) => {
          if (inputGuide) {
            const hintList = []
            inputGuide.forEach(guide => {
              hintList.push({
                content: guide.questionName.replace(val, `<span style="color: #ff7a59;">${val}</span>`),
                name: guide.questionName
              })
              this.hintList = hintList
            })
          }
        })
      }
    },
    h5ConfigData (val) {
      this.initWelcomes()
      this.$emit('scrollToBottom')
    },

    inputType (val) {
      if (val === 'audio' && !this.recorder && this.source === 'PC') {
        this.recorder = new Recorder({ onProcess: this.onProcess })
        this.recorder.open(
          _ => {
            console.log('open')
          },
          err => {
            this.$emit('showErrorTip', err)
          }
        )
      }
    }
  },

  methods: {
    initPC () {
      // Audio是用来放音的，放音目前屏蔽
      this.audioDom = new Audio()
      this.audioDom.addEventListener('error', this.handleAudioError)
      this.audioDom.addEventListener('ended', this.handleAudioEnded)
    },
    initAPP () {
      window.$hybrid = window.$hybrid || {}
      window.$hybrid.getAppAudio = (buffer) => {
        const blob = new Blob([buffer])
        this.success(blob)
      }
      window.$hybrid.handleAppError = this.fail
    },
    initWECHAT () {
      axios({
        method: 'get',
        url: `http://localhost:9000/sign?url=${window.location.href}&owner=${this.owner}`
      }).then((res) => {
        if (res.errcode) {
          this.$emit('showErrorTip', res.message || '微信接口权限验证失败')
        } else {
          wx.config({
            // debug: true, // 开启调试模式,
            appId: res.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名，见附录1
            jsApiList: ['startRecord', 'stopRecord'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          wx.ready(function () {
            this.isWXReady = true
          })
        }
      })
    },
    initWelcomes () {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      if (this.conversition.length === 0) {
        if (this.owner === 'SJTU') {
          this.sendSjtuMessage('init')
        } else {
          // this.userInput = '你好'
          if (vars.length > 1 && !this.search) {
            this.sendMessage(false, vars[1])
          }
        }
      }

      if (this.h5ConfigData.welcomes) {
        this.conversition.splice(0, 1, {
          type: 'answer',
          index: answerIndex++,
          content: new AnswerModel({
            CardType: 1,
            reply: { Title: this.h5ConfigData.welcomes }
          })
        })
      }
    },

    changeInput (val) {
      this.userInput = val
      if (this.owner === 'SJTU') {
        this.sendSjtuMessage()
      } else {
        this.sendMessage()
      }
    },
    clickHintHandler (content) {
      this.sendMessage(false, content)
    },
    sendSjtuMessage (isInit) {
      const userInput = this.userInput.trim()
      this.userInput = ''
      if (!userInput) {
        return
      }
      if (isInit !== 'init') {
        this.conversition.push({
          type: 'input',
          content: userInput
        })
      }
      this.$emit('scrollToBottom')
      if (
        H5AxiosSource.cancel &&
        {}.toString.call(H5AxiosSource.cancel) === '[object Function]'
      ) {
        H5AxiosSource.cancel('cancel request')
      }
      let realInput = userInput

      sjtuSendH5Message(
        realInput,
        '914013681'
      )
        .then(res => {
          if (res.code !== 200) {
            if (res.code === 300) {
              setTimeout(_ => {
                window.location.href = `https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=openid&client_id=UUOMZrMvXUFVtR7NwXbi&redirect_uri=${sjtuRoot}/ics/?owner=SJTU`
              }, 50)
            } else {
              this.$emit('showErrorTip', res.msg)
            }

            return
          }
          this.postHandleAnswer(res, isInit)
          this.conversition.push({
            type: 'answer',
            index: answerIndex++,
            content: new AnswerModel(res.result.result.dialog || {})
          })
          sessionStorage.setItem(
            'h5conversation',
            JSON.stringify(this.conversition)
          )

          this.$emit('scrollToBottom')
        })
        .catch(err => {
          console.log(err)
          this.$emit('showErrorTip', '网络出错，请再次发送')
        })
    },
    sendMessage (isInit = false, inputVal = '') {
      if (!this.h5ConfigData.configId) {
        return
      }
      const userInput = inputVal || this.userInput.trim()
      this.userInput = ''
      if (!userInput) {
        return
      }
      if (isInit !== 'init') {
        this.conversition.push({
          type: 'input',
          content: userInput
        })
      }

      this.$emit('scrollToBottom')
      if (
        H5AxiosSource.cancel &&
        {}.toString.call(H5AxiosSource.cancel) === '[object Function]'
      ) {
        H5AxiosSource.cancel('cancel request')
      }

      let realInput = userInput

      sendH5Message(
        realInput,
        this.h5ConfigData.productId,
        this.ifResVoice,
        this.h5ConfigData.voiceId,
        this.h5ConfigData.speed,
        this.h5ConfigData.volume
      )
        .then(res => {
          if (res.code !== '200') {
            this.$emit('showErrorTip', '发送消息失败')
            return
          }
          this.postHandleAnswer(res, isInit)
          if (res.result.artificial) { // 丰巢的转人工服务
            this.conversition.push({
              type: 'answer',
              index: answerIndex++,
              content: {
                ttsUrl: '',
                reply: {
                  CardType: 1,
                  Title: res.result.artificial.replyContent.trim().split('\n'),
                  empty: false

                }
              }
            })
          } else {
            res.result.result.reply.recordId = res.recordId
            this.conversition.push({
              type: 'answer',
              index: answerIndex++,
              content: new AnswerModel(res.result.result || {})
            })
          }

          sessionStorage.setItem(
            'h5conversation',
            JSON.stringify(this.conversition)
          )

          this.$emit('scrollToBottom')
        })
        .catch(err => {
          console.log(err)
          this.$emit('showErrorTip', '网络出错，请再次发送')
        })
    },

    startRecord () {
      if (!this.h5ConfigData.configId) {
        return
      }

      // this.clearCurAudioSrc()  //屏蔽放音
      this.ifWedgeInActive = true
      const func = `start${this.source}`
      if (typeof this[func] === 'function') {
        this[func]()
      }
      if (this.source === 'PC') {
        this.startPC()
      } else if (this.source === 'APP') {
        this.startAPP()
      } else if (this.source === 'WECHAT') {
        this.startWECHAT()
      }
    },

    startPC () {
      if (this.recorder) {
        this.recorder.open(
          _ => {
            this.recorder.start()
          },
          err => {
            this.$emit('showErrorTip', err)
          }
        )
      }
    },

    startAPP () {
      window.app.startRecord()
    },

    startWECHAT () {
      if (this.isWXReady) {
        wx.startRecord({
          success (res) {
            const tempFilePath = res.tempFilePath
            console.log('tempFilePath', tempFilePath)
          }
        })
        setTimeout(function () {
          this.stopRecord() // 结束录音
        }, 30000)
      }
    },

    success (blob) {
      const inputVoice = {
        type: 'input-voice',
        content: (window.URL || window.webkitURL).createObjectURL(
          blob
        )
      }
      this.conversition.push(inputVoice)

      this.$emit('scrollToBottom')
      this.$emit('update:isRequest', true)

      sendH5VoiceMessage(
        blob,
        this.h5ConfigData.productId,
        this.ifResVoice || this.h5ConfigData.ttsConfiguration === 4,
        this.h5ConfigData.voiceId,
        this.h5ConfigData.speed,
        this.h5ConfigData.volume
      )
        .then(res => {
          if (res.code !== '200') {
            this.$emit('showErrorTip', '发送消息失败')
            return
          }

          this.postHandleAnswer(res)

          if (
            res.result.msg &&
            res.result.msg.content &&
            res.result.msg.content.trim()
          ) {
            inputVoice.asr = res.result.msg.content
          }
          console.log('00000', res)
          this.conversition.push({
            type: 'answer',
            index: answerIndex++,
            content: new AnswerModel(res.result.result || {})
          })
          sessionStorage.setItem(
            'h5conversation',
            JSON.stringify(this.conversition)
          )

          this.$emit('scrollToBottom')
        })
        .catch(err => {
          console.log(err)
          this.$emit('showErrorTip', '网络出错，请再次发送')
        })
        .finally(_ => {
          this.$emit('update:isRequest', false)
        })
      if (this.source === 'PC') {
        this.recorder.close()
      }
    },
    fail (err) {
      if (err) {
        this.$emit('showErrorTip', err)
      }
      const func = `stop${this.source}`
      if (typeof this[func] === 'function') {
        this[func](true)
      }
    },
    stopRecord () {
      this.ifWedgeInActive = false

      const curRecordTime = parseInt(this.curRecordTime)
      this.$emit('update:voiceLevel', 0)
      this.$emit('update:curRecordTime', 0)

      if (curRecordTime > 30) {
        this.$emit('showErrorTip', '语音时长请控制在30秒以内')
      }
      if (curRecordTime < 1) {
        this.$emit('showErrorTip', '语音时长太短，录音已取消')
      }
      const func = `stop${this.source}`
      const err = !this.h5ConfigData.configId || curRecordTime < 1 || curRecordTime > 30
      if (typeof this[func] === 'function') {
        this[func](err)
      }
      if (this.source === 'PC') {
        this.stopPC()
      } else if (this.source === 'APP') {
        this.stopAPP()
      } else if (this.source === 'WECHAT') {
        this.stopWECHAT()
      }
    },
    stopPC (err) {
      if (!this.recorder) {
        return false
      } else if (err || !Recorder.IsOpen()) {
        this.recorder.close()
        return false
      } else {
        this.recorder.stop(this.success, this.fail)
      }
    },
    stopAPP (err) {
      window.app.stopRecord(!err)
    },
    stopWECHAT (err) {
      if (this.isWXReady) {
        wx.stopRecord({
          success: function (res) {
            if (!err) { // 如果没有错误，需要处理录音
            }
          }
        })
      }
    },
    postHandleAnswer (res, isInit) {
      if (
        isInit === 'init' &&
        res &&
        res.result &&
        res.result.result &&
        res.result.result.reply
      ) {
        res.result.result.reply = {}
      }

      if (
        res &&
        res.result &&
        res.result.result &&
        res.result.result.reply &&
        res.result.result.reply.Title === '服务出错拉'
      ) {
        res.result.result.reply = {}
        res.result.result.ttsUrl = ''

        if (this.inputType === 'audio') {
          this.$emit('showErrorTip', '未采集到录音或录音发送失败')
        } else {
          this.$emit('showErrorTip', '未能理解您的意思')
        }
      }
    },
    postHandleAnswerSjtu (res, isInit) {
      if (
        isInit === 'init' &&
        res &&
        res.result &&
        res.result.result &&
        res.result.result.dialog &&
        res.result.result.dialog.reply
      ) {
        res.result.result.dialog.reply = {}
      }

      if (
        res &&
        res.result &&
        res.result.result &&
        res.result.result.dialog &&
        res.result.result.dialog.reply &&
        res.result.result.dialog.reply.Title === '服务出错拉'
      ) {
        res.result.result.dialog.reply = {}
        if (this.inputType === 'audio') {
          this.$emit('showErrorTip', '未采集到录音或录音发送失败')
        } else {
          this.$emit('showErrorTip', '未能理解您的意思')
        }
      }
    },

    handleInputFocus ($event) {
      this.sent = 'https://oss.talkinggenie.com/ms-system/ecardServer/test/gallery/1000002541-2cc4cae6265047239032a69f4baf1176.png'
      setTimeout(() => {
        $event.target.scrollIntoView(false)
      }, 350)
    },

    handleInputBlur () {
      this.sent = 'https://oss.talkinggenie.com/ms-system/ecardServer/test/gallery/1000002541-5788768ecc784d02989c1809bab3818c.png'
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },
    noop () { },
    onProcess (_, level, time) {
      this.$emit('update:voiceLevel', Math.floor(level / 10) * 1.3)
      let secends = Math.round(time / 1000)
      if (secends < 10) {
        this.$emit('update:curRecordTime', '0' + secends)
      } else {
        this.$emit('update:curRecordTime', secends)
      }
    },
    /**
     * 下边的代码为放音需要，没有用到？？
     */
    setCurAudioSrc (type, val) {
      this.audioSrcType = type

      if (this.curAudioSrc === val) {
        if (this.checkAudioIsPlaying()) {
          this.audioDom.pause()
        } else {
          this.audioPlay()
        }
      } else {
        this.$emit('update:curAudioSrc', val)
        this.audioDom.src = val
        this.audioPlay()
      }
    },

    audioPlay () {
      this.audioDom.load()
      //   setTimeout(_ => {
      this.audioDom.play().catch(e => {
        setTimeout(_ => {
          this.audioDom.play().catch(e => {
            this.clearCurAudioSrc()
            console.log(e, 'playerror')
          })
        }, 150)
      })
      //   }, 150)
    },

    clearCurAudioSrc () {
      if (this.checkAudioIsPlaying()) {
        this.audioDom.pause()
      }
      this.audioDom.src = ''
      this.$emit('update:curAudioSrc', '')
    },

    checkAudioIsPlaying () {
      return (
        this.audioDom.currentTime > 0 &&
        !this.audioDom.paused &&
        !this.audioDom.ended &&
        this.audioDom.readyState > 2
      )
    },

    handleAudioError () {
      if (this.curAudioSrc) {
        if (this.audioSrcType === 'answer') {
          this.$emit('showErrorTip', '音频已失效')
        } else {
          this.$emit('showErrorTip', '录音文件读取失败')
        }
      }

      this.$emit('update:curAudioSrc', '')
      this.audioDom.src = ''
    },

    handleAudioEnded () {
      this.$emit('update:curAudioSrc', '')
      this.audioDom.src = ''
    }

  }
}
</script>

<style lang="scss" scoped>
.sjtu-sent {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: -42px;
}
.el-input {
    display: inline-block;
    width: 100%;
    height: 80px;
    padding: 12px 50px 12px 30px;
    line-height: 44px;
    border: none;
    border-radius: 12px;
    font-size: 32px; /*px*/
    color: #606266;
    background-color: #fff;
    margin-left: 24px;
    margin-right: 24px;
    background-image: none;
    outline: none;
    -webkit-appearance: none;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);

    &:hover {
        border-color: #c0c4cc;
    }

    &:focus {
        outline: none;
        border-color: #4e82ff;
    }
}

.iconfont {
    margin: 0 18px 0 24px;
    font-size: 56px; /*px*/
}

.el-input {
    flex: 1;
}

button {
    display: inline-block;
    margin: 0 24px 0 16px;
    line-height: 1;
    padding: 16px 20px;
    border: 1px solid #4e82ff;
    border-radius: 8px;
    font-size: 28px; /*px*/
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    color: #fff;
    background-color: #4e82ff;
    -webkit-appearance: none;
    outline: none;
    transition: 0.1s;
    user-select: none;
    cursor: pointer;

    &:active {
        background: #4675e6;
        border-color: #4675e6;
        color: #fff;
    }
}
.word-ask-cover {
    position: fixed;
    top: 0;
    bottom: 140px;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.24);
    z-index: 998;
}

.word-ask-hint {
    position: fixed;
    bottom: 140px;
    max-height: 270px;
    overflow-y: auto;
    left: 0;
    width: 100%;
    padding: 5px 15px;
    background: #ffffff;
    z-index: 999;
    text-align: left;
    div {
        font-size: 32px;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
        padding: 8px 0;
        overflow-x: hidden;
    }
}
.wedget-in {
    margin-right: 28px;
    flex: 1;
    height: 80px;
    line-height: 76px;
    border: 2px solid #dcdcdc;
    border-radius: 8px;
    font-size: 32px; /*px*/
    font-weight: 500;
    text-align: center;
    color: #606266;
    user-select: none;
    -webkit-touch-callout: none;
    &.active,
    &:active {
        background: #dcdcdc;
    }
}
.sjtu-btn {
    background: #016aed;
    border-color: #016aed;
}
.textarea {
    outline: none;
    resize: none;
}
.el-textarea {
    display: inline-block;
    width: 100%;
    padding: 12px 30px;
    border: 2px solid #dcdfe6;
    border-radius: 8px;
    font-size: 30px; /*px*/
    color: #606266;
    background-color: #fff;
    margin-left: 24px;
    background-image: none;
    outline: none;
    resize: none;
    -webkit-appearance: none;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    flex: 1;
    &:hover {
        border-color: #c0c4cc;
    }

    &:focus {
        outline: none;
        border-color: #4e82ff;
    }
}
.sjtu-tip {
    color: #606266;
    font-size: 12px;
    margin-top: 12px;
    p {
        text-align: center;
        line-height: normal;
    }
}
.el-input-sent {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 44px;
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/SimulatorFt.vue